import { render, staticRenderFns } from "./PageMyProfile.vue?vue&type=template&id=29857f47"
import script from "./PageMyProfile.vue?vue&type=script&lang=js"
export * from "./PageMyProfile.vue?vue&type=script&lang=js"
import style0 from "./PageMyProfile.vue?vue&type=style&index=0&id=29857f47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports